import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
import {LatestOutreachListItem} from 'shells/email-latest-outreach-list/latest-outreach-list-item';
// @ts-expect-error - imported from .js/.jsx file
import {BroadcastIcon} from 'shells/icon/svg/broadcast-icon';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import {appHistory} from '../../../../history';

import {NewBroadcastModal} from '../../broadcasts/new-broadcast-modal';
import {
    convertEmailEngagementStatsToGeneralStatObject,
    convertSmsEngagementStatsToGeneralStatObject,
} from '../../utils/helpers';

type Props = {
    audience: AudienceFragment;
};

export function AudienceLatestOutreach(props: Props) {
    const [isAddingNewBroadcast, setIsAddingNewBroadcast] = React.useState<boolean>(false);

    const latestOutreach = NutClientConfig.hasSmsAudiencesFF
        ? props.audience.mostRecentSentEdition
        : props.audience.publishedEditions.edges[0]?.node;

    if (latestOutreach) {
        const engagementStats =
            latestOutreach.__typename === 'SmsEdition'
                ? convertSmsEngagementStatsToGeneralStatObject(latestOutreach.engagementStats)
                : convertEmailEngagementStatsToGeneralStatObject(latestOutreach.engagementStats);

        const latestEdition = {
            ...latestOutreach,
            campaign: latestOutreach.campaign,
            engagementStats,
        } as const;

        return (
            <LatestOutreachListItem
                // @ts-expect-error
                edition={latestEdition}
                onView={() => {
                    appHistory.push(latestEdition.htmlUrlPath);
                }}
                hideAudience={true}
            />
        );
    }

    return (
        <React.Fragment>
            <CTABanner
                icon={BroadcastIcon}
                title={`Send your first message to ${props.audience.name}`}
                text='You can start from scratch or begin from an existing message.'
                buttonText='Create a broadcast'
                onPrimaryAction={() => {
                    setIsAddingNewBroadcast(true);
                }}
            />
            <NewBroadcastModal
                isOpen={isAddingNewBroadcast}
                onClose={() => {
                    setIsAddingNewBroadcast(false);
                }}
            />
        </React.Fragment>
    );
}
